import React from 'react';
import CommonLoader from '@/vdp/Loader';

type LoadingProps = {
  error?: Error | null;
  isLoading?: boolean;
};

const dynamicLoader =
  (section: string, loader?: () => React.JSX.Element) =>
  ({ error, isLoading }: LoadingProps) => {
    // eslint-disable-next-line no-console
    if (error) console.error('Error while loading', error);

    const Loader = loader || CommonLoader;

    return isLoading ? (
      <Loader className="section-is-loading" data-section={section} />
    ) : null;
  };

export default dynamicLoader;
